<template>
	<div id="app" :class="`var_page_${page}`">
		<transition @enter="onEnterPage">
			<div v-show="isLoaded">
				<div class="grid" :class="{ show: showGrid }" ref="grid">
					<div class="col_left">
						<div class="col_menu" ref="menu">
							<TheHeader ref="header" :showMenu="showMenu" />
						</div>
						<div class="col_content var_mobile" v-show="page === 'home'" id="advices-desktop">
							<a
								:href="legalWorkUrl"
								target="_blank"
								class="special-button"
								v-if="showLegallyWork"
								@mouseenter="onPointerMouseEnter($event)"
								@mouseleave="onPointerMouseLeave($event)"
							>
								{{ legalWorkCopy }}
								<svg
									data-v-f5f6924a=""
									data-v-5b878928=""
									width="19"
									height="16"
									viewBox="0 0 19 16"
									role="presentation"
									xmlns="http://www.w3.org/2000/svg"
								>
									<g
										data-v-f5f6924a=""
										id="icon-arrow-long"
										transform="translate(-1.000000, -8.000000)"
										fill="#000"
										fill-rule="nonzero"
									>
										<path
											data-v-f5f6924a=""
											d="M12.5646202,8.43234738 L12.6588275,8.51553598 L19.5583225,15.4150309 C19.5867597,15.4434682 19.6134922,15.4736102 19.6383535,15.5052905 L19.5583225,15.4150309 C19.5963934,15.4531018 19.6307529,15.4934787 19.661401,15.535712 L19.7297896,15.6439843 L19.7691525,15.724748 L19.8153705,15.8561447 L19.8310505,15.9213436 L19.844419,16.0049932 L19.8512157,16.1221377 C19.8512157,16.172758 19.8474545,16.2224998 19.8401963,16.2710989 L19.8154947,16.3879773 L19.7817269,16.4891305 L19.7560235,16.5485973 L19.7052758,16.6427555 L19.6315269,16.7475867 L19.5583225,16.8292445 L12.6588275,23.7287394 C12.2683032,24.1192637 11.6351383,24.1192637 11.244614,23.7287394 C10.88413,23.3682555 10.8564005,22.8010244 11.1614254,22.4087332 L11.244614,22.3145259 L16.437,17.122 L2.39305972,17.1221377 C1.84077497,17.1221377 1.39305972,16.6744225 1.39305972,16.1221377 C1.39305972,15.6093019 1.77909991,15.1866305 2.2764386,15.1288654 L2.39305972,15.1221377 L16.437,15.122 L11.244614,9.92974955 C10.88413,9.56926559 10.8564005,9.00203453 11.1614254,8.60974332 L11.244614,8.51553598 C11.5750576,8.18509235 12.0792262,8.13425487 12.4631237,8.36302354 L12.5646202,8.43234738 Z"
										></path>
									</g>
								</svg>
							</a>
							<AdvicesList />
						</div>
						<div class="col_logo">
							<IconLogoBig ref="logo" />
						</div>
						<div class="col_content">
							<transition :mode="mode" @enter="onRouterEnter" @leave="onRouterLeave">
								<router-view :key="currentSlug"></router-view>
							</transition>
						</div>
					</div>
					<div class="col_right var_hide_mobile" ref="advices" v-show="page === 'home'" id="advices-desktop">
						<a
							:href="legalWorkUrl"
							target="_blank"
							class="special-button"
							v-if="showLegallyWork"
							@mouseenter="onPointerMouseEnter($event)"
							@mouseleave="onPointerMouseLeave($event)"
						>
							{{ legalWorkCopy }}
							<svg
								data-v-f5f6924a=""
								data-v-5b878928=""
								width="19"
								height="16"
								viewBox="0 0 19 16"
								role="presentation"
								xmlns="http://www.w3.org/2000/svg"
							>
								<g
									data-v-f5f6924a=""
									id="icon-arrow-long"
									transform="translate(-1.000000, -8.000000)"
									fill="#000"
									fill-rule="nonzero"
								>
									<path
										data-v-f5f6924a=""
										d="M12.5646202,8.43234738 L12.6588275,8.51553598 L19.5583225,15.4150309 C19.5867597,15.4434682 19.6134922,15.4736102 19.6383535,15.5052905 L19.5583225,15.4150309 C19.5963934,15.4531018 19.6307529,15.4934787 19.661401,15.535712 L19.7297896,15.6439843 L19.7691525,15.724748 L19.8153705,15.8561447 L19.8310505,15.9213436 L19.844419,16.0049932 L19.8512157,16.1221377 C19.8512157,16.172758 19.8474545,16.2224998 19.8401963,16.2710989 L19.8154947,16.3879773 L19.7817269,16.4891305 L19.7560235,16.5485973 L19.7052758,16.6427555 L19.6315269,16.7475867 L19.5583225,16.8292445 L12.6588275,23.7287394 C12.2683032,24.1192637 11.6351383,24.1192637 11.244614,23.7287394 C10.88413,23.3682555 10.8564005,22.8010244 11.1614254,22.4087332 L11.244614,22.3145259 L16.437,17.122 L2.39305972,17.1221377 C1.84077497,17.1221377 1.39305972,16.6744225 1.39305972,16.1221377 C1.39305972,15.6093019 1.77909991,15.1866305 2.2764386,15.1288654 L2.39305972,15.1221377 L16.437,15.122 L11.244614,9.92974955 C10.88413,9.56926559 10.8564005,9.00203453 11.1614254,8.60974332 L11.244614,8.51553598 C11.5750576,8.18509235 12.0792262,8.13425487 12.4631237,8.36302354 L12.5646202,8.43234738 Z"
									></path>
								</g>
							</svg>
						</a>
						<AdvicesList />
					</div>
				</div>
				<div class="footer_wrapper" ref="footer">
					<div class="grid var_tablet">
						<IconFooter />
					</div>
					<div class="grid var_mobile">
						<IconFooterMobile />
					</div>
					<div class="footer_inner">
						<div class="grid" :class="{ show: showGrid }">
							<div class="col_bottom">
								<TheFooter />
							</div>
						</div>
					</div>
				</div>

				<span
					class="pointer"
					id="pointer1"
					ref="pointer"
					v-show="showPointer"
					:style="{ transform: `translate(${pointer.x}px, ${pointer.y}px)` }"
				></span>
				<span
					class="pointer var_2"
					:class="{ var_show: showDotInPointer }"
					ref="pointer2"
					v-show="showPointer"
					:style="{ transform: `translate(${pointer2.x}px, ${pointer2.y}px)` }"
				></span>

				<span class="home_overlay" ref="overlay"></span>
				<svg
					class="home_overlay_new"
					:style="svgZIndex"
					id="demo"
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
				>
					<defs>
						<mask id="theMask">
							<rect x="0" y="0" width="100%" height="100%" fill="#fff" />
							<circle id="cover" r="100" fill="black" cx="70%" cy="50%" />
						</mask>
						<clipPath id="theMask2">
							<circle ref="clipElement" id="cover" r="0" fill="black" :cx="overlay.x" :cy="overlay.y" />
						</clipPath>
						<pattern patternUnits="userSpaceOnUse" id="pat1" x="0" y="0" width="100px" height="96px">
							<image width="100px" height="96px" xlink:href="/images/patter-procore.png" />
						</pattern>
						<pattern patternUnits="userSpaceOnUse" id="pat2" x="0" y="0" width="100px" height="96px">
							<image width="100px" height="96px" xlink:href="/images/pattern-red.png" />
						</pattern>

						<pattern patternUnits="userSpaceOnUse" id="pat3" x="0" y="0" width="100px" height="96px">
							<image width="100px" height="96px" xlink:href="/images/pattern-news.png" />
						</pattern>
					</defs>

					<g clip-path="url(#theMask2)">
						<rect id="goAway" x="0" y="0" width="100%" height="100%" :fill="`url(${pattern})`" />
					</g>
				</svg>
			</div>
		</transition>
		<cookie-law />
		<LanguageSwitcher />
	</div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import TheHeader from "@/components/TheHeader";
import TheFooter from "@/components/TheFooter";
import LanguageSwitcher from "@/components/LanguageSwitcher";
import EventBus from "@/helpers/event-bus";

import AdvicesList from "@/components/AdvicesList";
import IconLogoBig from "@/components/icons/IconLogoBig";
import IconFooter from "@/components/icons/IconFooter";
import IconFooterMobile from "@/components/icons/IconFooterMobile";

import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { TextPlugin } from "gsap/TextPlugin";
import CookieLaw from "./components/CookieLaw.vue";
import PointerHoverMixin from "@/mixins/pointerHover";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(TextPlugin);

export default {
	name: "App",
	mixins: [PointerHoverMixin],
	props: {
		slug: String,
	},
	components: {
		AdvicesList,
		TheHeader,
		TheFooter,
		IconLogoBig,
		IconFooter,
		IconFooterMobile,
		LanguageSwitcher,
		CookieLaw,
	},
	computed: {
		...mapState({
			currentSlug: (state) => state.site.currentSlug,
			isLoaded: (state) => state.site.isLoaded,
			lang: (state) => state.site.currentLanguage,
			showLegallyWork: (state) => state.site.showLegallyWork,
			legallyWorkButton: (state) => state.site.legallyWorkButton,
			legalWorkButtonUrl: (state) => state.site.legalWorkButtonUrl,
		}),
		...mapGetters("page", ["currentPage"]),
		legalWorkCopy() {
			return this.legallyWorkButton[this.lang] || "";
		},
		legalWorkUrl() {
			return this.legalWorkButtonUrl[this.lang] || "#";
		},
		preventAnimation() {
			return this.router.to === this.router.from && this.router.to !== "home";
		},
		fromPageToPage() {
			return this.router.to === "page" && this.router.from === "page";
		},
		mode() {
			return this.fromPageToPage ? "" : "out-in";
		},
		showPointer() {
			return !this.isTouchDevice();
		},
		showMenu() {
			const hideMenu = this.currentPage?.hideMenu;
			return !hideMenu;
		},
		pattern() {
			if (this.router.to === "page" || this.router.from === "page") {
				return "#pat1";
			}
			if (
				this.router.to === "news" ||
				this.router.from === "news" ||
				this.router.to === "all-news" ||
				this.router.from === "all-news"
			) {
				return "#pat3";
			}

			return "#pat2";
		},
		doMenuAnimation() {
			return this.router.to === "page" || this.router.from === "page";
		},
		svgZIndex() {
			return {
				zIndex: this.doMenuAnimation ? 8 : 12,
			};
		},
	},
	data() {
		return {
			page: "home",
			showGrid: false,
			direction: 1,
			pageChangeTime: 0.7,
			logoAnimationInstance: null,
			interval: null,
			router: {
				to: "",
				from: "",
			},
			blockPointer: {
				x: false,
				y: false,
			},
			blockedPointer: {
				x: 0,
				y: 0,
			},
			pointer: {
				x: 0,
				y: 0,
			},
			pointer2: {
				x: 0,
				y: 0,
			},
			mouse: {
				x: 0,
				y: 0,
			},
			overlay: {
				x: 0,
				y: 0,
			},
			spans: [],
			maxR: 1000,
			showDotInPointer: false,
			absoluteElement: null,
		};
	},
	created() {
		this.$store.dispatch("site/getData");
		window.addEventListener("keydown", this.toggleGridVisibility);
		window.addEventListener("mousemove", this.onMouseMove);
		window.addEventListener("resize", this.onResize);
		this.interval = setInterval(this.updateMousePosition, 1000 / 60);
		EventBus.$on(EventBus.pointer.enter, this.onBlockPointer);
		EventBus.$on(EventBus.pointer.leave, this.onReleasePointer);
		EventBus.$on(EventBus.menu.reinit, this.getMenuElements);
	},
	mounted() {
		this.page = this.$route.name;
		this.countMaxR();
		this.getMenuElements();
	},
	methods: {
		getMenuElements() {
			setTimeout(() => {
				const menu = document.getElementById("menu");
				this.spans = menu.getElementsByTagName("li");
				this.lasSpanTop = this.spans[this.spans.length - 1].getBoundingClientRect().top;
			}, 500);
		},
		onBlockPointer(data) {
			const { el, type } = data;
			const spec = el.getBoundingClientRect();
			let width = spec.width;
			let height = spec.height;

			this.blockedPointer.x = spec.left + spec.width / 2;
			this.blockedPointer.y = spec.top + spec.height / 2;

			this.blockPointer.x = true;
			this.blockPointer.y = true;

			if (type === "text") {
				this.blockedPointer.x = spec.left - 20;
				width = 14;
				height = 14;
				this.showDotInPointer = true;
			}

			if (type === "top") {
				this.blockedPointer.x = spec.left + 50;
				this.blockedPointer.y = spec.top + 10;
				width = 36;
				height = 20;
			}

			if (type === "top2") {
				this.blockedPointer.x = spec.left + 20;
				this.blockedPointer.y = spec.top + 20;
				width = 36;
				height = 36;
			}

			if (type === "link") {
				this.blockPointer.x = false;
				this.blockPointer.y = false;
				width = 6;
				height = 6;
			}

			if (type === "lang") {
				width = 24;
				height = 24;
			}

			const multiple1 = 1.4;
			const multiple2 = 1.7;
			if (this.$refs.pointer) {
				gsap.set(this.$refs.pointer, {
					width: multiple2 * width,
					height: multiple2 * height,
					left: (-multiple2 * width) / 2,
					top: (-multiple2 * height) / 2,
				});
			}

			if (this.$refs.pointer2) {
				gsap.set(this.$refs.pointer2, {
					width: multiple1 * width,
					height: multiple1 * height,
					left: (-multiple1 * width) / 2,
					top: (-multiple1 * height) / 2,
				});
			}
		},
		onReleasePointer() {
			this.blockPointer.x = false;
			this.blockPointer.y = false;
			this.showDotInPointer = false;
			const widthLarge = 65;
			const heightLarge = 62;
			const widthSmall = 56;
			const heightSmall = 52;

			gsap.set(this.$refs.pointer, {
				width: widthLarge,
				height: heightLarge,
				left: -widthLarge / 2,
				top: -heightLarge / 2,
			});

			gsap.set(this.$refs.pointer2, {
				width: widthSmall,
				height: heightSmall,
				left: -widthSmall / 2,
				top: -heightSmall / 2,
			});
		},
		onResize() {
			this.countMaxR();
		},
		countMaxR() {
			this.maxR = Math.sqrt(Math.pow(window.innerWidth, 2) + Math.pow(window.innerHeight, 2));
		},
		setPointerFilled(el) {
			console.log("setPointerFilled", el);
		},
		setPointerClear(el) {
			console.log("setPointerFilled", el);
		},
		onEnterPage(el, done) {
			this.logoAnimation();
			done();
		},
		menuOutAnimation() {
			if (window.innerWidth <= 420) {
				const menu = document.getElementsByClassName("menu_wrapper")[0];
				// console.log(this.page);
				const y = this.page === "home" ? 90 : -90;
				const delay = this.page === "home" ? 0 : 0.6;
				gsap.to(menu, {
					y: y,
					duration: 0.4,
					delay: delay,
					ease: "power2.inOut",
				});
			} else {
				gsap.to(this.spans, {
					y: -this.lasSpanTop * 1.8,
					stagger: 0.1,
					duration: 0.35,
					delay: 0.1,
					ease: "power2.in",
				});
			}
		},
		menuInAnimation() {
			if (window.innerWidth <= 420) {
				const menu = document.getElementsByClassName("menu_wrapper")[0];
				gsap.set(menu, { clearProps: "transform" });
			} else {
				gsap.to(this.spans, {
					y: 0,
					stagger: -0.1,
					duration: 0.6,
					onComplete: () => {
						gsap.set(this.$refs.pointer, {
							width: 65,
							height: 62,
							left: -32,
							top: -31,
						});

						gsap.set(this.$refs.pointer2, {
							width: 56,
							height: 52,
							left: -28,
							top: -26,
						});
					},
				});
			}
		},
		onRouterEnter(el, done) {
			if (this.fromPageToPage) {
				setTimeout(() => {
					const title = el.getElementsByClassName("title")[0];
					const content = el.getElementsByClassName("modules_list")[0];
					const children = content.childNodes;
					this.absoluteElement = el;
					gsap.set(el, { position: "absolute", top: 0 });
					// gsap.set([title, children], { opacity: 0, x: 300 });

					gsap.fromTo(
						[title, children],
						{ x: 300, opacity: 0 },
						{
							x: 0,
							opacity: 1,
							duration: 0.5,
							stagger: {
								each: 0.05,
								onComplete: () => {
									console.log("finish el");
								},
							},
							delay: 0.5,
							ease: "power2.out",
							onComplete: () => {
								console.log("el finished");
								gsap.set(el, { position: "relative" });
								done();
							},
						}
					);
					return;
				}, 500);
			}

			if (this.preventAnimation) {
				done();
				return;
			}

			let animationDuration = 0.7;
			let animationDelay = 0;
			const back = document.getElementsByClassName("back");
			let targetBack = back[0];
			if (back.length > 1) {
				targetBack = back[1];
			}
			const backPosition = targetBack.getBoundingClientRect();

			this.overlay.x = backPosition.x + backPosition.width / 2;
			this.overlay.y = backPosition.y + backPosition.height / 2;

			if (this.doMenuAnimation) {
				this.menuInAnimation();
				animationDuration = 1;
				animationDelay = 0.5;
			}

			gsap
				.timeline({
					onComplete: () => {
						this.page = this.$route.name;
						gsap.set([this.$refs.pointer, this.$refs.pointer2], { opacity: 1 });
						done();
					},
				})
				.to(this.$refs.clipElement, { attr: { r: 0 }, duration: animationDuration, delay: animationDelay });
		},
		onRouterLeave(el, done) {
			if (this.fromPageToPage) {
				const title = el.getElementsByClassName("title")[0];
				const content = el.getElementsByClassName("modules_list")[0];
				const children = content.childNodes;
				gsap.fromTo(
					[title, children],
					{ x: 0, opacity: 1 },
					{
						x: -300,
						opacity: 0,
						delay: 0.1,
						duration: 0.75,
						stagger: 0.05,
						ease: "power2.in",
						onComplete: () => {
							gsap.set(this.absoluteElement, { position: "relative" });
							done();
						},
					}
				);
				// gsap.to(el, { opacity: 0, duration: 0.5, onComplete: () => done() });
				return;
			}

			if (this.preventAnimation) {
				done();
				return;
			}

			let animationDuration = 0.7;

			this.overlay.x = this.mouse.x;
			this.overlay.y = this.mouse.y;

			if (this.doMenuAnimation) {
				this.menuOutAnimation();
				animationDuration = 1;
			}

			gsap.set([this.$refs.pointer, this.$refs.pointer2], { opacity: 0 });
			gsap
				.timeline({
					onComplete: () => {
						this.page = this.$route.name;
						done();
					},
				})
				.to(this.$refs.clipElement, { attr: { r: this.maxR }, duration: animationDuration });
		},
		onMouseMove(ev) {
			if (!this.blockPointer.x) {
				this.mouse.x = ev.clientX;
			} else {
				this.mouse.x = this.blockedPointer.x;
			}

			if (!this.blockPointer.y) {
				this.mouse.y = ev.clientY;
			} else {
				this.mouse.y = this.blockedPointer.y;
			}
		},
		updateMousePosition() {
			this.pointer.x = this.lerp(this.pointer.x, this.mouse.x, 0.1);
			this.pointer.y = this.lerp(this.pointer.y, this.mouse.y, 0.1);
			this.pointer2.x = this.lerp(this.pointer2.x, this.mouse.x, 0.2);
			this.pointer2.y = this.lerp(this.pointer2.y, this.mouse.y, 0.2);
		},
		logoAnimation() {
			/*** Different ScrollTrigger setups for various screen sizes (media queries) ***/
			if (!this.$refs.logo) {
				return true;
			}

			ScrollTrigger.matchMedia({
				// mobile
				"(max-width: 420px)": () => {
					gsap.to(this.$refs.logo.$el, {
						scrollTrigger: {
							scrub: true,
							trigger: this.$el,
							start: "top top",
							end: "+=200",
						},
						scale: 0.5,
						transformOrigin: "top left",
					});
				},

				// all
				all: function() {
					// ScrollTriggers created here aren't associated with a particular media query,
					// so they persist.
				},
			});
		},
		toggleGridVisibility(e) {
			if ((e.keyCode === 71 || e.keyCode === 76) && e.ctrlKey) {
				// ctrl+g v ctrl+l
				this.showGrid = !this.showGrid;
			}
		},
		lerp(start, end, amt) {
			return (1 - amt) * start + amt * end;
		},
		isTouchDevice() {
			try {
				document.createEvent("TouchEvent");
				return true;
			} catch (e) {
				return false;
			}
		},
	},
	watch: {
		$route(to, from) {
			this.router.to = to.name;
			this.router.from = from.name;

			if (to.name === "home") {
				this.direction = -1;
			} else {
				this.direction = 1;
			}
		},
	},
};
</script>

<style lang="scss">
@import "@/scss/main.scss";

$time: 0.4s;
@keyframes border1 {
	0% {
		border-radius: 50% 100% 70% 60% / 80% 70% 80% 60%;
	}

	33% {
		border-radius: 80% 70% 80% 70% / 80% 70% 100% 70%;
	}

	66% {
		border-radius: 100% 50% 70% 90% / 90% 100% 60% 80%;
	}

	100% {
		border-radius: 50% 100% 70% 60% / 80% 70% 80% 60%;
	}
}

#app {
	min-height: 100vh;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	padding-top: 50px;

	// @include mq($to: m) {
	// overflow: hidden;
	// }

	@include mq($from: m) {
		padding-top: 70px;
	}

	@include mq($from: xl) {
		padding-top: 120px;
	}

	footer {
		flex: 0 0 100%;
	}

	.footer_wrapper {
		position: relative;
		padding-top: 50px;

		@include mq($from: m) {
			padding-top: 85px;
		}

		@include mq($from: xl) {
			padding-top: 170px;
		}

		.icon_footer {
			width: 100%;
		}

		.var_tablet {
			display: none;

			@include mq($from: m) {
				display: block;
			}
		}

		.var_mobile {
			display: block;

			@include mq($from: m) {
				display: none;
			}
		}
	}

	.footer_inner {
		position: relative;
		background: $colorGraphite;

		& * {
			color: #fff;
		}
	}
}

#app.var_page_home {
	.grid {
		.col_left {
			@include mq($to: m) {
				padding-top: 10px;
			}
		}
	}
}

#app.var_page_page {
	.grid {
		.col_left {
			@include gridColumn(s, 12, 0, false, true);

			@include mq($from: m) {
				@include gridColumn(m, 24, 0, false, true);
			}

			@include mq($from: xl) {
				@include gridColumn(xl, 24, 0, false, true);
			}

			.col_menu {
				@include mq($from: m) {
					z-index: 9;
					position: fixed;
					right: 7.5%;
					margin: 0;
					width: calc(min(19.929vw, 511px));
				}

				@include mq($from: 2100/0.85) {
					right: calc(50vw - 1050px);
				}

				@include mq($from: xl) {
				}
			}

			.col_content {
				width: 100%;

				@include mq($from: m) {
					padding: 0;
				}
			}
		}
	}
}

#app.var_page_all-news {
	.grid {
		.col_left {
			@include gridColumn(s, 12, 0, false, true);

			@include mq($from: m) {
				@include gridColumn(m, 24, 0, false, true);
			}

			@include mq($from: xl) {
				@include gridColumn(xl, 24, 0, false, true);
			}

			.col_menu {
				@include mq($from: m) {
					z-index: 9;
					position: fixed;
					right: 7.5%;
					margin: 0;
					width: calc(min(19.929vw, 511px));
				}

				@include mq($from: 2100/0.85) {
					right: calc(50vw - 1050px);
				}

				@include mq($from: xl) {
				}

				.menu_wrapper {
					display: none;
				}
			}

			.col_content {
				width: 100%;

				@include mq($from: m) {
					padding: 0;
				}
			}
		}
	}

	.col_logo {
		transition: none;
		opacity: 0;
		visibility: hidden;
		display: none;
	}
}

#app.var_page_news {
	.grid {
		.col_left {
			@include gridColumn(s, 12, 0, false, true);

			@include mq($from: m) {
				@include gridColumn(m, 24, 0, false, true);
			}

			@include mq($from: xl) {
				@include gridColumn(xl, 24, 0, false, true);
			}

			.col_menu {
				display: none;
			}

			.col_logo {
				position: relative;
				transform: none !important;
				left: auto;
				top: auto;
				width: 70%;
				width: 100%;
				opacity: 1;
				display: none;

				@include mq($from: m) {
					@include gridColumn(m, 14, 1, false, true);
					display: block;
					margin-top: -2vw;
					margin-bottom: -25px;
				}

				@include mq($from: l) {
					margin-top: -2.5vw;
					margin-bottom: -25px;
				}

				@include mq($from: xl) {
					@include gridColumn(xl, 10, 2, false, true);
					margin-bottom: 20px;
				}

				@include mq($from: 2500px) {
					margin-top: -62px;
				}

				svg {
					transform: none !important;
					width: 100%;
					height: auto;
				}
			}

			.col_content {
				width: 100%;

				@include mq($from: m) {
					padding: 0;
				}
			}
		}
	}
}

#app.var_page_advice {
	.grid {
		.col_left {
			@include gridColumn(s, 12, 0, false, true);

			@include mq($from: m) {
				@include gridColumn(m, 24, 0, false, true);
			}

			@include mq($from: xl) {
				@include gridColumn(xl, 24, 0, false, true);
			}

			.col_logo {
				top: 120px;

				@include mq($to: m) {
					svg {
						transform: scale(0.5) !important;
						transform-origin: 0% 0%;
					}
				}

				@include mq($from: m) {
					position: fixed;
					width: 100vw;
					left: 0;
					transform: none;

					svg {
						width: auto;
						height: 80vh;
						transform: translate(-95%, 0) !important;
					}
				}
			}

			.col_menu {
				display: none;
			}

			.col_content {
				width: 100%;
				padding-top: 0;

				@include mq($from: m) {
					padding: 0;
				}

				.lead {
					@include mq($to: m) {
						width: 82.7%;
					}
				}
			}
		}
	}
}

.var_page_page {
	.col_menu {
		@include mq($to: m) {
			position: sticky;
			top: 50px;
			z-index: 4;
		}
	}

	.col_logo {
		transition: none;
		opacity: 0;
		visibility: hidden;
		display: none;
	}
}

.grid {
	@include gridContainer();
	position: relative;
	align-items: flex-start;

	& > * > * {
		z-index: 3;
	}

	&.show {
		@include showGrid();
	}

	.col_left {
		@include gridColumn(s, 12, 0, false, true);

		display: flex;
		flex-wrap: wrap;
		align-items: flex-start;

		@include mq($from: m) {
			@include gridColumn(m, 11);
		}

		@include mq($from: xl) {
			@include gridColumn(xl, 15);
		}

		.col_menu {
			@include gridColumn(s, 12, 0, 12, true);
			z-index: 9;

			@include mq($from: m) {
				width: 61.37%;
				// @include gridColumn(m, 11, 0, 11, true);
			}

			@include mq($from: xl) {
				position: sticky;
				top: 120px;
				@include gridColumn(xl, 6, 0, 15, false);
			}
		}

		.col_content {
			@include gridColumn(s, 12, 0, 12, true);
			position: relative;
			z-index: 3;
			padding: 46px 0 80px;

			@include mq($from: m) {
				padding: 60px 0 0;
				@include gridColumn(m, 11, 0, 11, true);
			}

			@include mq($from: xl) {
				padding: 0 0 100px;
				@include gridColumn(xl, 7, 0, 15, true);
			}

			&.var_mobile {
				@include mq($to: m) {
					padding: 60px 0 24px;
				}

				@include mq($from: m) {
					display: none;
					visibility: hidden;
				}
			}
		}
	}

	.col_right {
		@include gridColumn(s, 12, 0, false, true);

		@include mq($from: m) {
			@include gridColumn(m, 12, 1, false, true);
			position: sticky;
			top: 70px;
		}

		@include mq($from: xl) {
			@include gridColumn(xl, 9, 0, false, true);
			top: 120px;
		}

		&.var_hide_mobile {
			@include mq($to: m) {
				display: none;
				visibility: hidden;
			}
		}
	}

	.col_bottom {
		position: relative;
		@include gridColumn(m, 24, 0, false, true);
	}
}

.col_logo {
	position: fixed;
	top: 40px;
	left: calc(100vw - 30px);
	transform-origin: 0 0;
	transform: rotate(90deg); //translate(-50%, -50%);
	width: 70vh;
	z-index: -1 !important;
	pointer-events: none;
	// transition: transform 0.3s;
	// transition: all .3s;

	@include mq($from: m) {
		position: relative;
		top: auto;
		left: auto;
		transform: none;
		margin-top: 50px;
		transform-origin: 100% 0;
	}

	@include mq($from: xl) {
		position: fixed;
		width: calc(min(85%, #{$pageMaxWidth}) + 200px);
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		margin-top: 0;
		max-width: 90%;

		.var_page_page & {
			position: absolute;
			top: 50vh;
		}
	}

	svg {
		width: 100%;
		height: auto;

		@include mq($from: m) {
			width: 85vw;
		}

		@include mq($from: xl) {
			width: 100%;
		}
	}
}

a.special-button {
	display: block;
	width: 135px;
	border: 2px solid $colorGraphite;
	border-radius: 50% 100% 70% 60% / 80% 70% 80% 60%;
	overflow: hidden;
	padding: 24px;
	font-family: $fontRubik;
	text-transform: uppercase;
	font-size: 14px;
	color: #000000;
	text-align: center;
	line-height: 17px;
	text-decoration: none;
	text-align: center;
	margin-bottom: 40px;

	svg {
		display: block;
		margin: 12px auto 0;
	}
}

.pointer {
	position: fixed;
	left: -32px;
	top: -31px;
	pointer-events: none;
	z-index: 10;

	display: block;
	width: 65px;
	height: 62px;
	border: 2px solid $colorRed1;
	border-radius: 50% 100% 70% 60% / 80% 70% 80% 60%;
	overflow: hidden;
	animation: border1 2s infinite linear;
	transition: width 0.3s, height 0.3s;
	will-change: width, height;

	&.var_2 {
		width: 56px;
		height: 52px;
		left: -28px;
		top: -26px;
		border: 2px solid $colorGraphite;

		&:after {
			content: "";
			display: block;
			width: 6px;
			height: 6px;
			border-radius: 50%;
			background: #000;
			position: absolute;
			top: calc(50% - 2px);
			left: calc(50% - 2px);
			opacity: 0;
			transition: opacity 0.3s;
		}

		&.var_show {
			&:after {
				opacity: 1;
			}
		}
	}

	// &:after {
	// 	position: absolute;
	// 	top: -25%;
	// 	left: -25%;
	// 	content: '';
	// 	display: block;
	// 	width: 150%;
	// 	height: 150%;
	// 	background: $colorRed1;
	// 	transform: scale(0);
	// 	transition: transform .3s;
	// 	border-radius: 50% 100% 70% 60% / 80% 70% 80% 60%;

	// }
}

.home_overlay {
	position: fixed;
	top: -21px;
	left: -23px;
	pointer-events: none;
	z-index: 8;

	display: block;
	width: 46px;
	height: 42px;
	// border: 2px solid $colorRed2;
	background: $colorRed1;
	background-size: 188px auto;
	background-attachment: fixed;
	border-radius: 50% 100% 70% 60% / 80% 70% 80% 60%;
	overflow: hidden;
	animation: border1 2s infinite linear;
	transform: scale(0);
}

.home_overlay_new {
	position: fixed;
	top: 0;
	left: 0;
	pointer-events: none;
	z-index: 8;
	width: 100vw;
	height: 100vh;
}

.fade-enter-active,
.fade-leave-active {
	transition: opacity 3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
	opacity: 0;
}
</style>

<style lang="scss">
a {
	text-decoration: underline;
}
</style>
